module.exports = __webpack_public_path__ + "static/media/IB_core_ee.eb8f46de.png";